import React, { useState } from "react";

const ReportBug = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true); 
  
    try {  
      const payload = {
        report_time: new Date().toISOString(), 
        report_message: message.replace(/\n/g, '\\n'),  
      };
      const response = await fetch("https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/bug-report",{
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });   
  
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
        alert("Thank you for your feedback! We will look into the issue shortly.");
      setIsSubmitting(false); // Reset the submitting state
      setIsModalOpen(false); // Close the modal
    }
  };
  

  return (
    <div>
      {/* Floating Button */}
      <button
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "#fff",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          cursor: "pointer",
          fontSize: "24px",
          zIndex: 1000,
        }}
        onClick={() => setIsModalOpen(true)}
      >
        🐞
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
            padding: "20px",
            zIndex: 1001,
          }}
        >
          <>Report a Bug</>
          <textarea
            placeholder="Describe the issue, we will automatically include a screenshot too. Thank you for helping us improve!"
            style={{ width: "100%", height: "100px", marginBottom: "10px" }}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <button onClick={() => setIsModalOpen(false)} disabled={isSubmitting}>
              Cancel
            </button>
            <button onClick={handleSubmit} disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportBug;
